import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {FormGroup, Input, Label} from "reactstrap"

class FilterName extends Component {
    _handleChangeName = (e) => {
        const {name, value} = e.target
        const {onChangeFilter} = this.props

        if (typeof onChangeFilter === 'function') {
            onChangeFilter(name, value)
        }
    }

    render() {
        const {name} = this.props

        return (
            <div className="FilterName">
                <FormGroup>
                    <Label className='font-weight-bold'>Tên </Label>
                    <Input type='text' name='name' value={name} placeholder='Nhập tên ...'
                           onChange={this._handleChangeName}/>
                </FormGroup>
            </div>
        )
    }
}

FilterName.propTypes = {
    name: PropTypes.string,
    onChangeFilter: PropTypes.func
}

export default FilterName